export default __webpack_public_path__ + "static/ilustration-3-19efcf8946e55c63a5936f41782d73c7.png";